module.exports = __webpack_public_path__ + "img/farms.b1f17441.png";